const config = {
  General1: "0_119240000",
};

export default config;
